(function(angular){
	'use strict';
	
	angular
		.module('formValidationModule')
		.directive('ngMax', ['FormValidationFactory', ngMaxFunction]);

	function ngMaxFunction(FormValidationFactory) {
		return {
			require: '?ngModel',
			restrict: 'A',
			link: function($scope, $elem, $attrs, ngModel) {

				$scope.$watch($attrs.ngMax, function(newValue) {
					FormValidationFactory.publishErrorVarsToModel({
						max: newValue
					}, ngModel);
				});
			}
		};
	}

})(window.angular);